import { render } from "./cnn-sia.vue?vue&type=template&id=36229836&scoped=true"
import script from "./cnn-sia.vue?vue&type=script&lang=js"
export * from "./cnn-sia.vue?vue&type=script&lang=js"

import "./cnn-sia.vue?vue&type=style&index=0&id=36229836&scoped=true&lang=css"

import exportComponent from "/Users/arissa/Desktop/code/portfolio/arissa-portfolio/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36229836"]])

export default __exports__